import { useSelector } from 'react-redux';
import { projectCohortPickerSelectors } from '../redux/modules/projectCohortPicker';

export const useActiveProjectCohortId = (): string =>
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  useSelector(projectCohortPickerSelectors.selectActiveProjectCohortId);

export default useActiveProjectCohortId;
